module.exports = __webpack_public_path__ + "img/facetes@2x.9b195da.jpg";